<template>
  <div class="toolbox-head toolbox-head-notebook" :class="{'hidden': selectedNum == 0}">
    <div class="header-wrap header-operate">
      <div class="header-operate-wrap">
        <div class="option-item" @click="selectLoaded">
          <i :class="{'icon-select-loaded-all': selectedNum !== loadedAllImageNum, 'icon-select-loaded': selectedNum === loadedAllImageNum}" :title="loadMsg"></i>
        </div>
        <div class="option-item" :class="{'disable': zeroCount === selectedImages.length}" @click="openShareBox">
          <i class="icon-share" :title="$t('operation.share')" v-if="zeroCount !== selectedImages.length"></i>
          <i class="icon-share" v-if="zeroCount === selectedImages.length"></i>
        </div>
        <div class="option-item" :class="{'disable': zeroCount === selectedImages.length}" @click="downloadImages">
          <i class="icon-download" :title="$t('operation.download')" v-if="zeroCount !== selectedImages.length"></i>
          <i class="icon-download" v-if="zeroCount === selectedImages.length"></i>
        </div>
      </div>
      <div class="header-right">
        <i class="icon-close" @click="closeSelected"></i>
        <span>{{$t('operation.selected')}} {{selectedNum}} {{$t('list.items')}}</span>
      </div>
    </div>
    <share-box v-if="showShareBox" :images="selectedImages" :shareType="selectedType" v-on:toCloseShareBox="closeShareBox"></share-box>
    <process-bar v-if="showProcessBar" :percentage="packageProcess" :text="loadingText"></process-bar>
  </div>
</template>

<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
import ShareBox from './ShareBox'
import ProcessBar from './ProcessBar'
export default {
  name: 'imageToolbox',
  components: {ShareBox, ProcessBar},
  props: ['selectedNum', 'selectedImages', 'selectedType', 'loadedAllImageNum'],
  data () {
    return {
      showShareBox: false,
      showProcessBar: false,
      packageProcess: 0,
      loadingText: this.$t('share.package'),
      packageTimer: null,
      zeroCount: 0
    }
  },
  created () {
  },
  watch: {
    selectedImages: function () {
      this.zeroCount = 0
      for (var i = 0; i < this.selectedImages.length; i++) {
        if (this.selectedImages[i].count === 0) {
          this.zeroCount += 1
        }
      }
      // console.log(this.zeroCount)
    }
  },
  computed: {
    loadMsg () {
      var msg = this.$t('operation.selectAllLoaded')
      if (this.selectedNum === this.loadedAllImageNum) {
        msg = this.$t('operation.deselectAll')
      }
      return msg
    }
  },
  methods: {
    downloadImages: function () {
      if (this.zeroCount === this.selectedImages.length) return
      this.showProcessBar = true
      this.packageProcess = 0
      var selectedId = []
      for (var i = 0; i < this.selectedImages.length; i++) {
        if (this.selectedType === 2) {
          selectedId.push(this.selectedImages[i].name)
        } else if (this.selectedType === 0 || this.selectedType === 1) {
          selectedId.push(this.selectedImages[i].id)
        }
      }
      selectedId = selectedId.join(',')
      // console.log(selectedId)
      HttpClient.postData(Config.APP_HOST + '/v1/book/batchDownload', {
        u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
        fileStrs: selectedId,
        type: this.selectedType
      }, this).then((response) => {
        // console.log(response)
        if (response.code === Config.R_CODE.SUCCESS) {
          // console.log(response)
          var key = response.body.redisKey
          this.packageUrl = response.body.downloadUrl
          var thisObj = this
          this.packageTimer = setInterval(function () {
            thisObj.getPackageProcess(key)
          }, 1000)
        }
      })
    },
    getPackageProcess: function (key) {
      HttpClient.postData(Config.APP_HOST + '/v1/book/batchDownloadProgress', {
        u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
        redisKey: key
      }, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          // console.log(response)
          var status = response.body.split(':')
          if (status[0] === 'download') {
            this.packageProcess = Math.round(status[1] / 4)
          } else if (status[0] === 'compress') {
            this.packageProcess = 25 + Math.round(status[1] / 2)
          } else if (status[0] === 'upload') {
            this.packageProcess = 75 + Math.floor(status[1] / 4)
          }
          if (this.packageProcess >= 100) {
            clearInterval(this.packageTimer)
            // this.computeOptions()
            this.closeSelected()
            var tempThis = this
            setTimeout(function () {
              tempThis.showProcessBar = false
              window.location.href = tempThis.packageUrl
            }, 100)
          }
        }
      })
    },
    closeShareBox: function () {
      this.showShareBox = false
    },
    openShareBox: function () {
      if (this.zeroCount === this.selectedImages.length) return
      this.showShareBox = true
    },
    selectLoaded: function () {
      if (this.selectedNum !== this.loadedAllImageNum) {
        this.$emit('selectedAll')
      } else {
        this.$emit('cancelSelectedAll')
      }
    },
    closeSelected: function () {
      this.$emit('closeSelected')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.toolbox-head-notebook
  width 100%
  height 50px
  line-height 50px
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  color #3d3d3d
  z-index 999
  &.hidden
    display none
  .header-wrap
    &.header-operate
      width 100%
      height 100%
      background-color #3d3d3d
      position relative
      .header-operate-wrap
        display flex
        width 240px
        height 100%
        margin 0 auto
        flex-direction row
        justify-content space-around
        align-items center
        .option-item
          position relative
          display flex
          width 80px
          height 50px
          flex-direction column
          justify-content space-around
          align-items center
          cursor pointer
          &.disable
            color #999999
            &:hover
              i
                transform none
                cursor default
            i
              color #999999
          &.hidden
            display none
          i
            display block
            width 22px
            height 22px
            font-size 22px
            color #fff
            line-height 22px
            cursor pointer
            transition all 0.2s ease-in
      .header-right
        height 100%
        position absolute
        top 0
        left 22px
        font-size 16px
        color #fff
        .icon-close
          font-size 12px
          vertical-align baseline
          margin-right 6px
          cursor pointer
@keyframes rotate
  0%
    transform rotate(0deg)
  100%
    transform rotate(45deg)
</style>



// WEBPACK FOOTER //
// src/components/Notebook/ImageToolbox.vue